import * as actions from "@p81-common/shell-core-js/dist/redux/regionsGet";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.REGIONS_GET_REQUEST]: (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
  }),
  [actions.REGIONS_GET_REQUEST_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      loading: false,
      loaded: true,
      error: null,
      data: action.data,
    }),
  [actions.REGIONS_GET_REQUEST_FAILURE]: (state, action) =>
    Object.assign({}, state, {
      loading: false,
      loaded: false,
      error: action.error,
      data: null,
    }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function regionsGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
